module.exports = __webpack_public_path__ + "img/scope3category6.0d4ef922.svg";